// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3PqFR","header":"Messages_header__eAULL"};